




























































import { getUserData } from "@/auth/getUserData";
import useAssignChat from "@/composables/v3/useAssignChat";
import { useChannelsStore } from "@/store/useChannelsStore";
import { useChatsStore } from "@/store/useChatsStore";
import { useTeamsStore } from "@/store/useTeamsStore";
import { useUsersStore } from "@/store/useUsersStore";
import { Team } from "@/types/team.types";
import { User } from "@/types/user.types";
import { resolveTeamsUsersTree, resolveUserStatus } from "@/utils/users";
import { Assignee, ChatsListChat } from "@saysimple-platform/dtos";
import { computed, defineComponent } from "@vue/composition-api";
import { ref } from "@vue/composition-api/dist/vue-composition-api";
import { BButton, BFormInput, VBTooltip } from "bootstrap-vue";

export default defineComponent({
    components: {
        BButton,
        BFormInput,
    },
    directives: {
        "b-tooltip": VBTooltip,
    },
    setup(_, { root }) {
        const chatsStore = useChatsStore();
        const usersStore = useUsersStore();
        const teamsStore = useTeamsStore();
        const channelsStore = useChannelsStore();

        const assignedUser = computed((): User => {
            if (chatsStore.activeChat?.chat.assignedUserId) {
                return usersStore.getUserById(chatsStore.activeChat.chat.assignedUserId);
            }
        });

        const assignedTeam = computed((): Team => {
            if (chatsStore.activeChat?.chat.assignedTeamId) {
                return teamsStore.getTeamById(chatsStore.activeChat.chat.assignedTeamId);
            }
        });

        const assignee = computed((): User | Team => assignedUser.value ?? assignedTeam.value);

        const assign = (chat: ChatsListChat, assignee: Assignee): void => {
            const { assign } = useAssignChat();
            assign(chat, assignee);

            root.$root.$bvModal.hide("modal-assign-to");
        };

        const unassign = (chat: ChatsListChat): void => {
            const { unassign } = useAssignChat();
            unassign(chat);

            root.$root.$bvModal.hide("modal-assign-to");
        };

        const dropdownSearchQuery = ref("");
        return {
            chatsStore,
            unassign,
            assign,
            assignee,
            resolveUserStatus,
            getUserData,
            usersTeamsTree: computed(() =>
                resolveTeamsUsersTree(
                    teamsStore.teams,
                    usersStore.users,
                    dropdownSearchQuery,
                    channelsStore.activeChatChannel
                )
            ),
            dropdownSearchQuery,
        };
    },
});
